import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {Localiser} from "../../../../services/localiser";

@Component({
  selector: 'app-info-fades',
  templateUrl: './info-fades.component.html',
  styleUrls: ['./info-fades.component.css']
})
export class InfoFadesComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<InfoFadesComponent>, public localiser: Localiser) { }

  ngOnInit(): void {
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
